<template>
    <div
        :class="action === '1' ? ['fixedLeftPerson', 'fixedLeftDiv'] : ['tourist-service']"
        @click="openChatDialog"
    >
        <template v-if="action === '1'">
            <img :src="require('@/assets/homeImages/message.png')">
            <p class="fixedLeftP">{{ $t('Online Service') }}</p>
        </template>
        <!-- 登录页在线客服入口 -->
        <template v-else>
            <i class="iconfont iconzaixiankefu" />
            <span class="text">{{ $t('Online Service') }}</span>
        </template>

        <v-chat-width-employee-tim v-if="isTIM" />
        <!-- <v-chat-width-employee /> -->
    </div>
</template>

<script>
// import ChatWithEmployee from '@/components/Chat/ChatWithEmployee'
import ChatWithEmployeeTim from '@/components/Tim/ChatWithEmployee'
import { mapState, mapGetters } from 'vuex'

export default {
    components: {
        'v-chat-width-employee-tim': ChatWithEmployeeTim
        // 'v-chat-width-employee': ChatWithEmployee
    },
    props: {
        action: {
            type: String,
            default: ''
        }
    },
    computed: {
        ...mapState('chat', [ 'touristService' ]),
        ...mapState({
            customerServiceInfo: state => state.timStore.customerServiceInfo,
            currentUserProfile: state => state.timStore.currentUserProfile,
            conversationList: state => state.timStore.conversationList
        }),
        ...mapGetters([ 'isLogin' ]),
        ...mapGetters([ 'ident', 'isLogin', 'locale', 'config', 'isTIM' ])
    },
    mounted() {
        // this.getInfo()
    },

    methods: {

        // 打开聊天框
        async openChatDialog() {
            //     // 接收在线客服
            if (this.$store.getters.isLogin) {
                if (!this.$store.getters.isSDKReady || !this.$store.getters.timIsLogin) {
                    await this.$store.dispatch('getOnlineCustomer', this.$store.getters.isLogin)
                }
            }
            if (this.isTIM) {
                await this.$store.commit('toogleShowList', false)
                console.log(this.$store)

                // 在线客服IM id
                const userID = this.customerServiceInfo.id
                let conversationID = `C2C${userID}`
                if (userID !== '@TIM#SYSTEM') {
                    // 判断是否为在线客服
                    if (this.currentUserProfile.userID === userID) {
                        conversationID = this.conversationList[0].conversationID
                    }
                    await this.$store.dispatch('checkoutConversation', conversationID)
                        .then(async() => {
                            console.log('===========拉取会话列表成功===========')
                            await this.$store.commit('toogleChatDialog')

                        }).catch(async(imError) => {
                            // const message = JSON.parse(JSON.stringify(imError)).message
                            const message = this.$t('拉取会话失败')
                            console.log('imError--->', JSON.parse(JSON.stringify(imError)).message)
                            // console.log('===========拉取会话列表失败11111111111===========', message)
                            await this.$store.commit('showMessage', {
                                message: message || '拉取会话列表失败',
                                type: 'warning'
                            })
                        })
                }
                return
            }
        }
    }
}
</script>

<style  lang="stylus">
.tourist-service {
    cursor: pointer;
    .iconzaixiankefu {
        // color: $color-main;
        margin: 0;
        vertical-align: middle;
    }
    .text {
        margin-top: -2px;

        &:hover {
            color $color-main
        }
    }
}
</style>
